module.exports = "<p>\n  record-page-transfer works!\n</p>\n"